import React, { useEffect, useState } from 'react'
import { GoDotFill } from 'react-icons/go'
import ViewTasktable from './MitigationComponents/ViewTasktable'
import TaskMonitoring from './MonitoringViewComponents/TaskMonitoring'
import { Controller, useForm } from 'react-hook-form'
import { useRiskStore } from './Store/RiskStore'
import { useGovernanceStore } from '../Onboarding/Store/GovernanceStore'
import { Slider } from '@mui/material'
import DateInput from 'src/Common/ui/dateInput'
import * as RiskTypes from '../../Entities/RiskTypes'
import { Button } from 'src/Common/ui/button'
import { RxCross2 } from 'react-icons/rx'
import { createMitigationPlan } from 'src/API/RiskAPI'
import { LiaSaveSolid } from 'react-icons/lia'
import { cn } from 'src/lib/utils'
import { toast } from 'react-toastify'
import Textarea from 'src/Common/ui/textArea'

const MonitoringEdit = ({ setIsEditTrue }) => {
    const { formState: { errors }, register, control } = useForm()
    const { RiskDetailsById } = useRiskStore()
    const [ formData, setFormData ] = useState({})
    const { allDepartments } = useGovernanceStore()
    const [ updatedRiskScore, setUpdatedRiskScore ] = useState()
    const [ loading, setLoading ] = useState(false)
    useEffect(() => {
        if (RiskDetailsById?.monitering) {
            const data = RiskDetailsById?.monitering
            setFormData(data)
            setUpdatedRiskScore({ impact: data?.updatedScoring?.impact, impactOfRisk: data?.updatedScoring?.impactOfRisk, Probability: data?.updatedScoring?.probability, RiskScore: data?.updatedScoring?.riskScore })
        }
    }, [RiskDetailsById])

    const checkScoreValue = (obj1, obj2) => {
        return (
            obj1?.impact === obj2?.impact &&
            obj1?.RiskScore === obj2?.riskScore &&
            obj1?.Probability === obj2?.probability
        )
    }

    useEffect(() => {
        if (formData?.taskLists?.length > 0) {
            const checkedCount = formData?.taskLists?.filter((filData, _) => filData?.actions !== 11)?.filter(item => item?.actions === RiskTypes.TASK_COMPLETED_STATUS)?.length
            setFormData({ ...formData, taskListScoring: (checkedCount / formData?.taskLists?.filter((filData, _) => filData?.actions !== 11)?.length) * 100 })
        }
    }, [formData?.taskLists?.length])

    const handleValueFormat = value => {
        return `${value} %`
    }
    const userId = localStorage.getItem('userId')
    const riskDetails = location?.state?.riskDetails
    const { getRidkDetailsById } = useRiskStore()

    const onSubmit = (message) => {
        setLoading(true)
        const dat = {
            id: formData.id,
            riskId: formData.riskId,
            approachId: formData.approachId,
            justification: formData.justification,
            mitigationBudget: formData.mitigationBudget,
            resolutionDate: formData.resolutionDate,
            createdBy: formData.createdBy,
            createdAt: formData.createdAt,
            modifiedBy: formData.modifiedBy,
            modifiedAt: formData.modifiedAt,
            reviewDate: RiskDetailsById?.mitigation?.reviewDate
        }
        const riskSc = RiskDetailsById?.mitigation?.scoring
        let UpRiskScore = riskSc
        UpRiskScore = { ...UpRiskScore, impact: updatedRiskScore.impact, riskScore: updatedRiskScore?.RiskScore, impactOfRisk: updatedRiskScore?.impactOfRisk, probability: updatedRiskScore?.Probability, status: 19 }
        dat.createTasks = { riskId: formData.riskId, riskScore: { ...UpRiskScore, userId, impactOfRisk: updatedRiskScore?.impactOfRisk }, taskListRequests: formData.taskLists }
        createMitigationPlan(dat).then((ele) => {
            if (ele?.data) {
                toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{message.replace('[ID]', RiskDetailsById?.riskInformation?.referenceId)}</p></p>, {
                    position: 'top-right', theme: 'light'
                })
                getRidkDetailsById(riskDetails?.riskId, userId)
                setIsEditTrue(false)
                setLoading(false)
            } else {
                toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>Monitoring changes have not been saved for Risk. Please try again!</p></p>, {
                    position: 'top-right', theme: 'light'
                })
                setLoading(false)
            }
        })
    }
    const handleCancel = () => {
        setIsEditTrue(false)
    }
    return (
        <div className='text-primary flex flex-col h-[100%]'>
            <div className={cn(RiskDetailsById?.riskInformation?.status === 21 ? 'h-[90%]' : 'h-[100%]', 'overflow-auto flex flex-col gap-7 p-5')}>
                <div className='text-primary text-lg font-[500] p-3 rounded-md bg-[hsl(var(--primary-table-head))] w-[100%] flex items-center gap-2'><GoDotFill size={8} /> Task Monitoring</div>
                <TaskMonitoring updatedRiskScore={updatedRiskScore} setUpdatedRiskScore={setUpdatedRiskScore} formData={formData} setFormData={setFormData} edit />
                <div className="grid grid-cols-3 gap-10 w-full pr-10">
                    <div>
                        <Controller
                            name="actions"
                            rules={{ required: 'This field is Required' }}
                            control={control}
                            errors={errors}
                            render={({ field: { onChange } }) => (
                                <DateInput
                                    label={'Resolution Date'}
                                    required
                                    name="selectedDate"
                                    className={'input-grc date-mointor'}
                                    value={formData?.resolutionDate}
                                    defaultValue={formData?.resolutionDate}
                                    onValueChange={(e) => {
                                        setFormData({ ...formData, resolutionDate: e })
                                    }}
                                />
                            )}
                        />
                    </div>
                    <div>
                        <p className="text-muted grc-label">Task Completion Percentage</p>
                        <Slider
                            valueLabelDisplay="auto"
                            value={formData?.taskListScoring || 0}
                            valueLabelFormat={handleValueFormat}
                            sx={{
                                marginTop: 4,
                                height: 13,
                                color: 'hsl(var(--primary))',
                                '& .MuiSlider-rail': {
                                    color: 'transparent',
                                    border: '1px solid hsl(var(--primary))'
                                },
                                '& .MuiSlider-thumb': {
                                    borderRadius: '2px',
                                    width: '10px',
                                    color: '#d8d8d8'
                                },
                                '& .MuiSlider-valueLabel': {
                                    backgroundColor: 'transparent',
                                    color: 'hsl(var(--muted))',
                                    minWidth: 9,
                                    borderRadius: 2,
                                    border: '1px solid hsl(var(--primary))'
                                }
                            }}
                        />
                    </div>
                    <div>
                        <div className="relative" style={{ marginBottom: '2%' }}>
                            <Textarea disabled={checkScoreValue(updatedRiskScore, formData?.updatedScoring)} className={cn('ml-[0px]')} label="Impact of Risk" rules={{
                                validate: (value) => {
                                    if (!value) return 'This field is required'
                                    if (value.length > 251) return 'Character count should not exceed 250'
                                    return true
                                }
                            }} register={register} value={updatedRiskScore?.impactOfRisk} type="text" placeholder="Enter Impact of Risk" onValueChange={(e) => setUpdatedRiskScore({ ...updatedRiskScore, impactOfRisk: e?.slice(0, 250) })} name="impactOfRisk" errors={errors} control={control} required maxLength={250} />
                            <div className={cn('absolute bottom-[25px] right-[10px] text-muted text-[10px]', updatedRiskScore?.impactOfRisk?.length > 250 ? '!text-danger' : 'text-muted')}>{updatedRiskScore?.impactOfRisk?.length || 0}/250</div>
                        </div>
                    </div>
                </div>
                <ViewTasktable data={formData?.taskLists} formData={formData} monitoringEdit setFormData={setFormData} departments={allDepartments} />
            </div>
            {RiskDetailsById?.riskInformation?.status === 21 && <div className='h-[10%] items-center flex flex-row gap-7 p-5 justify-end'>
                <div className="flex space-x-4">
                    <Button
                        onClick={() => handleCancel()}
                        variant='outline'
                        style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                    >
                        <RxCross2 className="mr-2" size={18} /> {'Cancel'}
                    </Button>
                    <Button onClick={() => onSubmit('Monitoring changes have been saved for Risk [ID]')} disabled={loading}>
                        <LiaSaveSolid className="mr-2" size={15} /> Save
                    </Button>
                </div>
            </div>}
        </div>
    )
}

export default MonitoringEdit
